import { z } from "zod";

export const SourceDocumentSchema = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  page_number: z.number().optional().nullable(),
  bounding_box: z
    .array(z.tuple([z.number(), z.number()]))
    .optional()
    .nullable(),
  page_height: z.number().optional().nullable(),
  page_width: z.number().optional().nullable(),
});

export type SourceDocument = z.infer<typeof SourceDocumentSchema>;
